import {connect} from "react-redux"
import State from "../../models/State"

export const mapStateToProps = (state: State) => {
    const {template} = state
    const {siteUrl, useDevEsi, url} = state.request
    const {totalResults, title} = state.search
    return {
        templating: template,
        siteUrl,
        useDevEsi,
        url,
        totalResults,
        title,
    }
}

export default connect(mapStateToProps)
